import React, { useState } from 'react';

// bootstrap
import { Row, Col, Form } from 'react-bootstrap';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectBookingForm, setBookingForm } from '_redux/slices/assistance-bookings/booking-form';


// utils
import { Colors } from '_styles';

const AirportSelector = (props) => {

    // redux
    const dispatch = useDispatch();
    const bookingForm = useSelector(selectBookingForm);

    // states
    const [originAssistance, setOriginAssistanceState] = useState(true);
    const [destinationAssistance, setDestinationAssistanceState] = useState(true);

    const setOriginAssistance = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { originAssistance: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
        setOriginAssistanceState(value)
    }

    const setDestinationAssistance = (value) => {
        let tempList = [...bookingForm]; // copy list
        const newObj = Object.assign({}, tempList[props.index], { destinationAssistance: value });        // create a new object with a writable firstName property
        tempList[props.index] = newObj; // update list with new object
        dispatch(setBookingForm(tempList));
        setDestinationAssistanceState(value)
    }

    return (
        <>
            {
                <Row xs={7}>
                    <Col>
                        <div style={{ display: 'flex' }}>
                            <Form.Check
                                onClick={(e) => { setOriginAssistance(!originAssistance) }}
                                type="switch"
                                defaultChecked={true}
                            />
                            <p style={{ marginLeft: 8, color: bookingForm.originAssistance ? 'green' : Colors.TEXT_COLOR }}>Origin Airport</p>
                        </div>
                    </Col>
                    <Col>
                        <div style={{ display: 'flex' }}>
                            <Form.Check
                                onClick={(e) => { setDestinationAssistance(!destinationAssistance) }}
                                type="switch"
                                defaultChecked={true}
                                id="create-course-form"
                            />
                            <p style={{ marginLeft: 8, color: bookingForm.destinationAssistance ? 'green' : Colors.TEXT_COLOR }}>Destination Airport</p>
                        </div>
                    </Col>
                    {
                        props.errors && props.errors.assistanceSelector && (
                            <p className="text-danger" style={{ color: Colors.TEXT_COLOR }}>{props.errors.assistanceSelector}</p>
                        )
                    }
                </Row>
            }
        </>
    );
};

export default AirportSelector;